import { RadialBarChart, RadialBar, PolarAngleAxis } from "recharts";

export function scoreColor(score) {
  if (score == null) return "#71717a";
  if (score >= 75) return "#10B981"; // emerald
  if (score >= 50) return "#F59E0B"; // amber
  return "#EF4444"; // red
}

export function scoreLabel(score) {
  if (score == null) return "—";
  if (score >= 75) return "Strong";
  if (score >= 50) return "Needs work";
  return "At risk";
}

export function ScoreGauge({ score, size = 220, testId = "visibility-score-gauge" }) {
  const color = scoreColor(score);
  const data = [{ name: "score", value: score ?? 0, fill: color }];
  return (
    <div className="relative" style={{ width: size, height: size }} data-testid={testId}>
      <RadialBarChart
        width={size}
        height={size}
        cx="50%"
        cy="50%"
        innerRadius="78%"
        outerRadius="100%"
        barSize={14}
        data={data}
        startAngle={90}
        endAngle={-270}
      >
        <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
        <RadialBar background={{ fill: "hsl(var(--muted))" }} dataKey="value" cornerRadius={12} isAnimationActive animationDuration={1100} />
      </RadialBarChart>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-mono text-5xl font-medium tracking-tight" style={{ color }}>
          {score ?? "—"}
        </span>
        <span className="mt-1 text-xs uppercase tracking-widest text-muted-foreground">
          {scoreLabel(score)}
        </span>
      </div>
    </div>
  );
}
